<mat-nav-list class="menu-list">
  <mat-list-item class="parent home" [disabled]="!isKeyAutomateEnabled">
    <a routerLink="/key-cabinet" class="p-0">
      <img src="../../../../assets/images/home.png" height="62">
    </a>
  </mat-list-item>
  <!-- <mat-list-item ValidSubscription routerLinkActive="active">
    <a routerLink="/invoicing">

      <mat-icon class="material-icons-outlined" mat-list-icon>home_outline</mat-icon>
    </a>
  </mat-list-item> -->
  <mat-list-item ValidSubscription routerLinkActive="active" matTooltip="Key Cabinet" matTooltipPosition="right"
    [disabled]="!isKeyAutomateEnabled" matTooltipClass="side-menu-tooltip">
    <a routerLink="/key-cabinet">
      <mat-icon class="material-icons-outlined" mat-list-icon>key_outline</mat-icon>
    </a>
  </mat-list-item>
  <mat-list-item ValidSubscription routerLinkActive="active" matTooltip="Calendar" matTooltipPosition="right"
    [disabled]="!isKeyAutomateEnabled" matTooltipClass="side-menu-tooltip">
    <a routerLink="/calendar">
      <mat-icon class="material-icons-outlined" mat-list-icon>event</mat-icon>
    </a>
  </mat-list-item>
  <mat-list-item ValidSubscription routerLinkActive="active" matTooltip="Manage Key Borrowers"
    matTooltipPosition="right" [disabled]="!isKeyAutomateEnabled" matTooltipClass="side-menu-tooltip"
    style="display: flex; align-items: center; justify-content: center;"
    class="d-flex align-items-center justify-contet-center">
    <a routerLink="/key-borrower">
      <img class="key-borrow-img" src="../../../../assets/images/user-key-icon.svg" width="20" height="20">
    </a>
  </mat-list-item>
  <mat-list-item *ngIf="maintenanceAppEnabled" routerLinkActive="active" matTooltip="Maintenance"
    [disabled]="!isKeyAutomateEnabled" matTooltipPosition="right" matTooltipClass="side-menu-tooltip">
    <a [href]="maintenanceAppUrl">
      <mat-icon class="material-icons-outlined" mat-list-icon>handyman</mat-icon>
    </a>
  </mat-list-item>
  <mat-list-item ValidSubscription routerLinkActive="active" matTooltip="Manage Keys" matTooltipPosition="right"
    [disabled]="!isKeyAutomateEnabled" matTooltipClass="side-menu-tooltip"
    style="display: flex; align-items: center; justify-content: center;"
    class="d-flex align-items-center justify-contet-center">
    <a routerLink="/manage-keys">
      <span class="material-symbols-outlined">vpn_key_alert</span>
    </a>
  </mat-list-item>
  <mat-list-item routerLinkActive="active" matTooltip="Invoice Automate" matTooltipPosition="right"
    [disabled]="!isKeyAutomateEnabled" matTooltipClass="side-menu-tooltip" *ngIf="invoiceProcessorEnabled">
    <a [href]="invoiceAutomateUrl">
      <mat-icon class="material-icons-outlined" mat-list-icon>receipt</mat-icon>
    </a>
  </mat-list-item>
  <!-- <mat-list-item ValidSubscription routerLinkActive="active">
    <a routerLink="/invoicing">
      <mat-icon class="material-icons-outlined" mat-list-icon>manage_accounts_outline</mat-icon>
    </a>
  </mat-list-item>
  <mat-list-item ValidSubscription routerLinkActive="active">
    <a routerLink="/invoicing">
      <mat-icon class="material-icons-outlined" mat-list-icon>calendar_month_outline</mat-icon>
    </a>
  </mat-list-item>-->
  <mat-list-item ValidSubscription routerLinkActive="active" matTooltip="Settings" matTooltipPosition="right"
    matTooltipClass="side-menu-tooltip" [disabled]="!isLeadOrgAdmin">
    <a routerLink="/setting">
      <mat-icon class="material-icons-outlined" mat-list-icon>settings</mat-icon>
    </a>
  </mat-list-item>

</mat-nav-list>